module.exports = __webpack_public_path__ + "static/media/sb.ab93a799.svg";